import { render } from "./TheTuyenDenDuong.vue?vue&type=template&id=ac5c3d54"
import script from "./TheTuyenDenDuong.vue?vue&type=script&lang=js"
export * from "./TheTuyenDenDuong.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__